module.exports = __webpack_public_path__ + "static/media/rRNA_seqs_preprocessing.8cbfda73.png";